import { validator } from "@/utils/schema";

const authDataSchema = {
  type: "object",
  required: ["token", "prod"],
  properties: {
    token: {
      type: "string"
    },
    prod: {
      type: "string"
    }
  }
};

const imDataSchema = {
  type: "object",
  required: ["appKey", "roomId", "token", "accid", "name"],
  properties: {
    appKey: {
      type: "string"
    },
    roomId: {
      type: "number"
    },
    token: {
      type: "string"
    },
    accid: {
      type: "string"
    },
    name: {
      type: "string"
    }
  }
};

export const checkAuthData = validator(authDataSchema);
export const checkImData = validator(imDataSchema);
